import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=1c7fe96f&"
import script from "./ButtonIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports